module.exports = __webpack_public_path__ + "img/2b989eb.jpg";